import React, { useState } from "react"
import Col from "react-bootstrap/Col"
import Form from "react-bootstrap/Form"
import Row from "react-bootstrap/Row"
import { images } from "../../../services/utils/images"
import { useContactAction } from "../../actions/useContactAction"
import { useGetStartedAction } from "../../actions/useGetStartedAction"
import Button from "../../components/Layout/Button"
import { ButtonCta } from "../../components/Layout/ButtonCta"
import Container from "../../components/Layout/Container"
import { HelmetTitle } from "../../components/Layout/HelmetTitle"
import Wrapper from "../../components/Layout/Wrapper"
import styles from "./ContactPage.module.scss"
import Banner from "../../components/Banner"
import classnames from "classnames"
import { SeoTags } from "../../components/Layout/SeoTags"
import ReCAPTCHA from "react-google-recaptcha"
import { Box, CircularProgress } from "@material-ui/core"

const ContactPage = ({ gallery }) => {
  const {
    form,
    setForm,
    onSubmit,
    success,
    error,
    errorMessage,
    onReCAPTCHAChange,
    recaptchaRef,
    loading,
  } = useContactAction(gallery)
  const { email, setEmail, handleClick } = useGetStartedAction()
  const contactTitle = `Contact ${(gallery && gallery.name) || "Us"}`
  const bannerDescription = (
    <p>
      Visit 
      <a href="https://www.artplacer.com" target="_blank">
        <u>ArtPlacer</u>
      </a>{" "}
      to learn more or 
      <a href="https://www.artplacer.com/signup" target="_blank">
        <u>Join</u>
      </a>
       to become a Partner Gallery.
    </p>
  )
  const buttonLabel = () => {
    const label = (gallery && "CONTACT GALLERY") || "SUBMIT"

    return loading ? (
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <CircularProgress size={18} color="inherit" />
      </Box>
    ) : (
      label
    )
  }

  return (
    <div>
      <SeoTags
        title="Contact Us | Discover ArtPlacer"
        description="Get in touch and let us know how we can help."
        url="https://discover.artplacer.com/contact"
        canonical="https://discover.artplacer.com/contact"
      />
      <HelmetTitle title={contactTitle} />
      <div className="contactBanner">
        <Banner
          image={images.contact.header}
          height={308}
          title={contactTitle}
          description={bannerDescription}
          contact={true}
        />
      </div>
      <Container>
        <Container>
          <Row>
            <Col
              xs={12}
              sm={12}
              md={{ span: 10, offset: 1 }}
              lg={{ span: 10, offset: 1 }}>
              {success && (
                <Row>
                  <div className="w-100 alert alert-success">
                    Your message was sent successfully
                  </div>
                </Row>
              )}
              {error && (
                <Row>
                  <div className="w-100 alert alert-danger">
                    {errorMessage.map((error) => (
                      <div>
                        {error}
                        <br />
                      </div>
                    ))}
                  </div>
                </Row>
              )}
              <Row className="align-items-center">
                <Col md={6} xs={{ order: "last" }} sm={{ order: "first" }}>
                  <div
                    className={classnames(
                      styles.rightPostal,
                      "d-flex flex-column justify-content-end",
                    )}
                    style={{
                      backgroundImage: `url(${images.contact.side})`,
                    }}>
                    <div className="container">
                      <div className="text-lg-left z-1 position-relative ">
                        <h2 className="color-white fs-34px">
                          Showcase your work. <br />
                          Create your own Gallery Profile.
                        </h2>
                        <div className={styles["form-control"]}>
                          <br />
                          <ButtonCta
                            className="w-100"
                            title="Free 14-day Trial"
                            onClick={handleClick}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col md={6} xs={{ order: "first" }} sm={{ order: "last" }}>
                  <h4 className="pt-4">
                    Looking for product support? Visit our
                    <a
                      href="http://help.artplacer.com/support/home"
                      target="_blank">
                      {" "}
                      <u>Help Center</u>
                    </a>{" "}
                    or let us know how we can help.
                  </h4>
                  <Form onSubmit={onSubmit}>
                    <Form.Group
                      controlId="exampleForm.ControlInput1"
                      className="mb-4">
                      <Form.Label className="text-capitalize fs-14px text-black">
                        Email
                      </Form.Label>
                      <Form.Control
                        className={styles.inputFontSize}
                        type="email"
                        onChange={(event) => {
                          setForm({ ...form, email: event.target.value })
                        }}
                        value={form.email}
                        disabled={loading}
                      />
                    </Form.Group>

                    <Row>
                      <Form.Group
                        as={Col}
                        controlId="firstName"
                        className="mb-2 pr-2 pl-3">
                        <Form.Label className="text-capitalize text-black fs-14px">
                          First Name
                        </Form.Label>
                        <Form.Control
                          className="input-font-size"
                          type="name"
                          placeholder="ie: Joe"
                          onChange={(event) => {
                            setForm({ ...form, firstname: event.target.value })
                          }}
                          value={form.firstname}
                          disabled={loading}
                        />
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        controlId="lastName"
                        className="mb-2 pl-2 pr-3">
                        <Form.Label className="text-capitalize text-black fs-14px">
                          Last Name
                        </Form.Label>
                        <Form.Control
                          className="input-font-size"
                          type="name"
                          placeholder="ie: Doe"
                          onChange={(event) => {
                            setForm({ ...form, lastname: event.target.value })
                          }}
                          value={form.lastname}
                          disabled={loading}
                        />
                      </Form.Group>
                    </Row>

                    <Form.Group
                      controlId="exampleForm.ControlTextarea1"
                      className="mb-4">
                      <Form.Label className="text-capitalize fs-14px text-black">
                        Message
                      </Form.Label>
                      <Form.Control
                        className={styles.inputFontSize}
                        as="textarea"
                        rows="3"
                        onChange={(event) => {
                          setForm({ ...form, body: event.target.value })
                        }}
                        value={form.body}
                        disabled={loading}
                      />
                      <div className="font-primary color-gray-super-light fs-12px mt-1">
                        One of our curators or a member of our support team will
                        be in touch as soon as possible.
                      </div>
                    </Form.Group>

                    <Form.Group
                      controlId="exampleForm.ControlSelect2"
                      className="mb-4">
                      <Form.Label className="text-capitalize fs-14px text-black">
                        Phone Number
                      </Form.Label>
                      <Form.Control
                        className={styles.inputFontSize}
                        type="number"
                        onChange={(event) => {
                          setForm({ ...form, phone: event.target.value })
                        }}
                        value={form.phone}
                        disabled={loading}
                      />
                      <div className="font-primary color-gray-super-light fs-12px mt-1">
                        Please only include numbers: XXXXXXXXXX
                      </div>
                    </Form.Group>

                    <ReCAPTCHA
                      ref={recaptchaRef}
                      size="invisible"
                      sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
                      onChange={onReCAPTCHAChange}
                    />

                    <hr className="mb-4" />
                    <Button disabled={loading} type="submit">
                      {buttonLabel()}
                    </Button>
                  </Form>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </Container>
    </div>
  )
}

export default ContactPage
